<template>
  <div id="about">
    <section>
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 px-0">
            <img
              src="./../../assets/images/banner/home-banner.png"
              class="w-100 banner-home"
            />
            <div class="banner-caption">
              <h3>
                <b>{{ $t("pages.HomeReg1") }}</b
                ><br /><b>{{ $t("pages.HomeReg2") }}</b
                ><br /><b>{{ $t("pages.HomeReg3") }}</b
                ><br /><b>{{ $t("pages.HomeReg4") }}</b>
              </h3>
              <router-link
                to="/register"
                class="btn btn-outline-light btn-width rounded-0"
                >{{ $t("button.click") }}</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="pt-3 pb-5">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="text-center my-4 font-h4">
              <b
                >{{ $t("pages.aboutPromotion1") }}<br />{{
                  $t("pages.aboutPromotion3")
                }}
                {{ $t("pages.aboutPromotion2") }}
              </b>
            </h1>
          </div>
          <div class="col-12 col-md-3 text-center mb-3 mb-lg-0">
            <img
              src="./../../assets/images/icon/agent.png"
              height="71"
              class="mb-3"
            />
            <p>{{ $t("pages.aboutDesc1") }}</p>
          </div>
          <div class="col-12 col-md-3 text-center mb-3 mb-lg-0">
            <img
              src="./../../assets/images/icon/mark.png"
              height="71"
              class="mb-3"
            />
            <p>{{ $t("pages.aboutDesc2") }}</p>
          </div>
          <div class="col-12 col-md-3 text-center mb-3 mb-lg-0">
            <img
              src="./../../assets/images/icon/people.png"
              height="71"
              class="mb-3"
            />
            <p>{{ $t("pages.aboutDesc3") }}</p>
          </div>
          <div class="col-12 col-md-3 text-center">
            <img
              src="./../../assets/images/icon/doc.png"
              height="71"
              class="mb-3"
            />
            <p>
              {{ $t("pages.aboutDesc4") }}
            </p>
          </div>
          <div class="col-12">
            <div class="border-top my-5"></div>
          </div>
        </div>
        <!--<div class="container">
          <div class="row">
            <div id="app">
              <my-video
                :sources="video.sources"
                :options="video.options"
              ></my-video>
            </div>
          </div>
        </div>-->
        <!--<div class="border-top my-5"></div>-->
        <div class="row">
          <div class="col-12 col-md-7 border-right">
            <h5 class="pl-4 pb-4">
              <b>{{ $t("pages.contact") }} Rental Agentcloud</b>
            </h5>
            <div class="row px-4">
              <div class="col-12 col-lg-6 mb-4 mb-lg-0">
                <p>
                  <b>{{ $t("pages.address") }}</b>
                </p>
                <p class="my-2">{{ $t("pages.address_desc") }}</p>
              </div>
              <div class="col-12 col-lg-6">
                <div class="border border-2 border-blue mb-3 p-3">
                  <img
                    src="./../../assets/images/icon/tel-black.png"
                    class="d-inline mr-2"
                  />
                  {{ data.telephone }}
                </div>
                <div class="border border-2 border-blue p-3">
                  <img
                    src="./../../assets/images/icon/email.png"
                    class="d-inline mr-2"
                  />
                  <span class="email-font">{{ data.email }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-5">
            <div
              class="
                mt-5
                pt-4
                pb-4
                mt-lg-5
                pt-lg-5
                position-relative
                w-100
                float-left
                block-social-mobile
              "
            >
              <div class="d-lg-inline mr-lg-3 social-mobile">
                <img
                  src="./../../assets/images/icon/line.png"
                  class="d-block d-lg-inline mr-lg-1 mb-2 mb-lg-0"
                />
                {{ data.lineName }}
              </div>
              <!--<div class="d-lg-inline social-mobile pb-2 pb-lg-0">
                <img
                  src="./../../assets/images/icon/face.png"
                  class="d-block d-lg-inline mr-lg-1 mb-2 mb-lg-0"
                />
                {{ data.facebookName }}
              </div>-->
            </div>
          </div>
        </div>
        <div class="row pt-5">
          <div class="col-12">
            <div class="float-left mr-2">
              <b>{{ $t("pages.location") }}</b> :
            </div>
            <div class="float-left border-fac fs-15">
              <a href="https://g.page/siri-campus?share" target="_blank"
                ><b>{{ $t("pages.see") }} Google Map</b></a
              >
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="bg-grey py-1">
      <div class="container">
        <div class="row">
          <!--<div class="col-12">
            <h4 class="pb-3">
              <b>{{ $t("pages.projectForRent") }}</b>
            </h4>
          </div>
          <div class="col-12 col-lg-6 pr-lg-0">
            <slick ref="slick1" :options="slickOptions1" class="slider-for">
              <img
                :src="item.photoFeature"
                class="w-100"
                v-for="(item, i) in extraUnit"
                :key="i"
              />
            </slick>
          </div>
          <div class="col-12 col-lg-6 pl-lg-0">
            <div class="bg-white p-4 mt-lg-4 slide-caption-about">
              <slick
                ref="slick2"
                :options="slickOptions2"
                @afterChange="handleAfterChange"
                class="slider-nav"
              >
                <div v-for="(item, i) in extraUnit" :key="i">
                  <h5 class="mt-2">
                    <b>{{ item["projectName_" + $i18n.locale] }}</b>
                  </h5>
                  <p>{{ item["description_" + $i18n.locale] }}</p>
                </div>
              </slick>
              <div class="text-right mt-4">
                <div
                  class="count-slide mr-3 position-relative"
                  style="right: -9px; top: -6px"
                >
                  <div class="d-inline text-blue position-relative">
                    <b id="current-slide">1</b>
                  </div>
                  <div class="d-inline">
                    <img
                      src="./../../assets/images/icon/slash.png"
                      height="50"
                    />
                  </div>
                  <div
                    class="text-grey d-inline position-relative"
                    style="top: 10px; left: -10px"
                  >
                    <b>{{ extraUnit.length }}</b>
                  </div>
                </div>
                <div class="arrow-slide">
                  <div class="arrow-left" @click="prev()">
                    <i class="icon-slide-left"></i>
                  </div>
                  <div class="arrow-right" @click="next()">
                    <i class="icon-slide-right"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>-->
          <div class="col-12 pt-1 text-center">
            <router-link to="/register" tag="button" class="btn btn-primary">{{
              $t("pages.joinAgent")
            }}</router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
//import Slick from "vue-slick";
//import myVideo from "vue-video";
export default {
  components: {
    // Slick,
    // myVideo,
  },
  data() {
    return {
      data: Object,
      slickOptions1: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: ".slider-nav",
      },
      /*slickOptions2: {
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: ".slider-for",
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        arrows: false,
      },*/
      /*video: {
        sources: [
          {
            src:
              //"https://drive.google.com/drive/u/0/folders/1LjUFkJ3pWVXDkEcheE5G7ZSgwzvodkJR/SSR_SUB_08oct.mp4",
              "https://www.radiantmediaplayer.com/media/big-buck-bunny-360p.mp4",
              //"./../../assets/video/SSR_SUB_08oct.mp4",
            type: "video/mp4",
          },
        ],
        options: {
          autoplay: true,
          volume: 0.6,
          poster: "./../../assets/images/icon/slash.png",
        },
      },*/

      extraUnit: [],
    };
  },
  mounted() {
    this.getAbout();
    this.getExtraUnit();
  },
  methods: {
    getAbout() {
      let loading = this.$loading.show();
      this.$http.get(this.$app.baseURL + this.$path.about).then(
        (res) => {
          loading.hide();
          this.data = res.data.data[0];
        },
        () => {
          loading.hide();
        }
      );
    },
    /*next() {
      this.$refs.slick2.next();
    },

    prev() {
      this.$refs.slick2.prev();
    },*/
    handleAfterChange(event, slick, currentSlide) {
      document.getElementById("current-slide").innerHTML = currentSlide + 1;
    },
    getExtraUnit() {
      this.$http
        .get(this.$app.baseURL + this.$path.getExtra)
        .then((res) => (this.extraUnit = res.data.data));
    },
  },
  /*beforeUpdate() {
    if (this.$refs.slick1) {
      this.$refs.slick1.destroy();
      this.$refs.slick2.destroy();
    }
  },
  updated() {
    this.$nextTick(function () {
      if (this.$refs.slick1) {
        this.$refs.slick1.create(this.slickOptions1);
        this.$refs.slick2.create(this.slickOptions2);
      }
    });
  },*/
};
</script>

<style scoped>
.form-register {
  position: absolute;
  top: 50px;
  right: 50px;
  background: rgba(255, 255, 255, 0.8);
  padding: 20px;
  width: 300px;
  border-radius: 5px;
}

.btn-width {
  min-width: 100px;
}
</style>